import BaseAPI from '@/apis/base/baseApi';

export default class OpeningAPI extends BaseAPI {
  apiName = 'OPN';
}
